import { websiteEnv } from './website-env';
/** 尺码使用cm单位的国家 */
export const IS_USE_CENTIMETERS_SIZE_COUNTRY =
  websiteEnv.isCanada ||
  websiteEnv.isAustralia ||
  websiteEnv.isNewZealand ||
  websiteEnv.isGermanyEnglish ||
  websiteEnv.isSingapore;
